import { BulkPhotoUpload, type BulkPhotoConfig, type PhotoOutcome } from '../components/BulkPhotoUpload';

interface StaffPhotoOutcome extends PhotoOutcome {
  employeeCode: string | null;
}

const config: BulkPhotoConfig<StaffPhotoOutcome> = {
  eyebrow: 'Staff',
  title: 'Upload staff photographs',
  intro: (
    <>
      A whole folder at once. Name each photograph with the employee code —
      <strong> PH-01.jpg</strong>, <strong>PH-02.jpg</strong> — then zip the folder and upload it
      here. Sub-folders are fine, and lower-case filenames are matched too.
    </>
  ),
  uploadPath: '/api/staff/photos/bulk',
  smallPrint: (
    // ⚠ No consent sentence here, unlike the student screen, and the difference is real rather than
    // an oversight: a staff photograph is processed for the ID card and the directory on the basis
    // of the employment relationship, not a consent that an employee could not freely refuse.
    <>
      JPEG or PNG, up to 5 MB each and 50 MB for the zip. Used on the staff ID card and in the
      directory.
    </>
  ),
  keyLabel: 'Employee code',
  keyOf: (o) => o.employeeCode,
  allMatched: 'Every file matched a member of staff and was saved.',
};

export function StaffPhotosPage() {
  return <BulkPhotoUpload config={config} />;
}
